module.exports = {
  API_URL_DEV: "https://webback.dgrnte.net",
  API_URL: "https://webback.dgrnte.net",
  LOCALE_URL: "/translation/list?locale={{lng}}",
  PORT_NUMBER: "8000"
};
